// initial state
const state = () => ({
  guest: {},
})

// getters
const getters = {
}

// actions
const actions = {
  getGuest({commit},userSlug) {
    return new Promise((resolve, reject) => {
    axios.get("/api/guest/" + userSlug)
         .then(response => {
               commit('saveGuest', response.data);
               resolve(response.data);
         }, error => {
          reject(error);
         });
        });
 },
}
// mutations
const mutations = {
  saveGuest(state, guest) {
    state.guest= guest;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}